import dynamic from 'next/dynamic';
import withHomeLayout from "@/components/hoc/withHomeLayout";
const MetaTag = dynamic(() => import('@/components/ui/MetaTag'), { ssr: false });
const Hero = dynamic(() => import('@/components/home/Hero'), { ssr: false });
const WhyChooseUs = dynamic(() => import('@/components/home/WhyChooseUs'), { ssr: false });
const ServicesOverview = dynamic(() => import('@/components/home/ServicesOverview'), { ssr: false });
const AISolutions = dynamic(() => import('@/components/home/AISolutions'), { ssr: false });
const Products = dynamic(() => import('@/components/home/Products'), { ssr: false });
const IndustriesServed = dynamic(() => import('@/components/home/IndustriesServed'), { ssr: false });
const ClientTestimonials = dynamic(() => import('@/components/home/ClientTestimonials'), { ssr: false });

function Home({ data }) {
  const canonicalUrl = `${window.location.href}`;

  const breadcrumbSchema = {
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": canonicalUrl
    }]
  };

  const faqSchema = {
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What services does SCC Infotech provide?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We provide comprehensive digital solutions including web development, mobile app development, AI solutions, custom software development, and digital transformation services."
        }
      },
      {
        "@type": "Question",
        "name": "What technologies do you work with?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We work with a wide range of technologies including React, Node.js, Flutter, Laravel, AWS, and more."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide post-development support?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide comprehensive post-development support including maintenance, updates, and bug fixes."
        }
      }
    ]
  };

  return (
    <>
      <MetaTag
        title="SCC Infotech | Home"
        description="SCC Infotech is a leading provider of digital solutions, specializing in web, mobile, and AI-powered products."
        keywords="SCC Infotech, web development, mobile apps, AI solutions, digital transformation"
        siteName="SCC Infotech"
        ogType="website"
        locale="en_US"
        twitterHandle="@sccinfotech"
        image="/images/logo.webp"
        canonical={canonicalUrl}
        schemaType="WebSite"
        schemaData={{
          url: canonicalUrl,
          name: "SCC Infotech",
          description: "Leading provider of digital solutions and IT services",
          potentialAction: {
            "@type": "SearchAction",
            "target": `${canonicalUrl}`,
          },
          breadcrumb: breadcrumbSchema,
          faq: faqSchema
        }}
      />

      <Hero />
      <main className="h-full bg-gradient-to-b from-gray-50 to-white">
        <WhyChooseUs />
        <ServicesOverview data={data?.services} />
        <AISolutions />
        <Products data={data?.products} />
        <IndustriesServed data={data?.industries} />
        <ClientTestimonials data={data?.testimonials} />
      </main>
    </>
  );
}

export default withHomeLayout(Home);

export async function getStaticProps() {
  const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

  try {
    const formData = new FormData();
    formData.append('action', 'getHomeData');

    const response = await fetch(`${BACKEND_URL}/manageData`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error('Response is not JSON');
    }

    const data = await response.json();

    return {
      props: { data },
      revalidate: 300,
    };
  } catch (error) {
    console.error('Fetch home data error:', error);
    return {
      props: { data: null },
      revalidate: 60,
    };
  }
}